import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Heart } from "lucide-react";
import { toast } from "sonner";
import { AppShell } from "@/components/AppShell";
import { ListCard } from "@/components/cards";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n/I18nContext";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Favorites() {
  const { user } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [favs, setFavs] = useState([]);

  const load = () => api.get("/favorites").then((r) => setFavs(r.data)).catch(() => {});
  useEffect(() => { if (user) load(); }, [user]);

  const remove = async (barcode) => {
    await api.delete(`/favorites/${barcode}`).catch(() => {});
    setFavs((f) => f.filter((x) => x.barcode !== barcode));
    toast.success(t("favorites.removed"));
  };

  return (
    <AppShell>
      <button onClick={() => navigate("/")} className="text-emerald-600 font-semibold flex items-center gap-1" data-testid="fav-back">
        <ArrowLeft className="w-4 h-4" /> {t("history.title")}
      </button>
      <h1 className="font-heading text-4xl font-extrabold text-slate-900 mt-3 mb-4">{t("favorites.title")}</h1>

      {!user ? (
        <div className="text-center py-16 px-6">
          <Heart className="w-12 h-12 text-emerald-500 mx-auto mb-4" />
          <p className="text-slate-500 mb-6">{t("favorites.loginPrompt")}</p>
          <Button onClick={() => navigate("/auth")} className="rounded-full bg-emerald-600 hover:bg-emerald-700 h-12 px-8">{t("common.login")}</Button>
        </div>
      ) : favs.length === 0 ? (
        <div className="text-center py-16 px-6" data-testid="fav-empty">
          <Heart className="w-12 h-12 text-slate-300 mx-auto mb-4" />
          <p className="text-slate-500">{t("favorites.empty")}</p>
        </div>
      ) : (
        <div>{favs.map((s) => (
          <ListCard key={s.barcode} item={s} right={
            <button onClick={(e) => { e.stopPropagation(); remove(s.barcode); }} data-testid={`remove-fav-${s.barcode}`} className="text-red-500 self-center shrink-0 mr-1">
              <Heart className="w-5 h-5 fill-current" />
            </button>
          } />
        ))}</div>
      )}
    </AppShell>
  );
}
